import {FrameProfileInterface, FrameProfileType} from "./frame-profile";
import {ColorConverter} from "../../../../../core/util/color-converter";
import {CreateProfileParams, GeneralProfileFactory} from "../general-profile/general-profile.factory";

const profileModelTable: {[key:string]: string} = {
    'no frame profile': null,
    "frame profile 50x70": 'p-17839.obj',
    "frame profile 70x78": 'p-17061.obj'
}

export type CreateFrameProfileParams = {
    type: FrameProfileType,
} & CreateProfileParams;

export class FrameProfileFactory extends GeneralProfileFactory {

    public static override createProfile(

        params: CreateFrameProfileParams = {
            productCode: null,
            type: 'no frame profile',
            materialType: 'Powder Coated',
            color: '#FFFFFF',
        }

    ): FrameProfileInterface {
        return {
            id: 10,
            productCode: params.productCode,
            materialType: params.materialType,
            color: ColorConverter.convert(params.color),
            type: params.type,
            object3dUrl: profileModelTable[params.type]
        }
    }

}